import { render, staticRenderFns } from "./PaginatedPiecesList.vue?vue&type=template&id=4d67e6fa&scoped=true&"
import script from "./PaginatedPiecesList.vue?vue&type=script&lang=js&"
export * from "./PaginatedPiecesList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedPiecesList.vue?vue&type=style&index=0&id=4d67e6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d67e6fa",
  null
  
)

export default component.exports